import React, {useState} from "react";
import 'moment/locale/fr';
import { TextField, Grid  } from "@mui/material";

import { Popup, PopupBody, PopupFooter, PopupHeader, PopupTitle } from "../../component/Popup/Popup";

export default function AddUpdateCategoryPopup(props) {
    const [category, setCategory] = useState(props.category ?
        {
            id: props.category.id,
            name: props.category.name,
            calendarLink: props.category.calendarLink,
            rankLink: props.category.rankLink
        } : {
            name: "",
            calendarLink: "",
            rankLink: ""
    });
    const [error, setError] = useState(false);

    function handleSubmit() {
        let tmpCategory = category;

        if (category.name == null || category.name === "") {
            setError(true);
            return;
        }
        if (category.rankLink === "") {
            tmpCategory.rankLink = null;
        }

        if (category.calendarLink === "") {
            tmpCategory.calendarLink = null;
        }
       props.submit(tmpCategory);
    }

    return (
        <Popup size={"large"} close={props.close}>
            <PopupHeader>
                <PopupTitle>{props.category ? "Modifier une categorie" : "Créer une nouvelle categorie"}</PopupTitle>
            </PopupHeader>

            <PopupBody>
                <Grid container direction={"column"} justifyContent={"space-between"} alignItems={"center"}>
                    <Grid item>
                        <TextField sx={{margin: "1rem"}} inputProps={{min: 0, style: { textAlign: 'center' }}} type={"text"} label={"Nom de la categorie"} defaultValue={category.name} onChange={(event) => {
                            let tmp = category;
                            tmp.name = event.target.value;
                            setCategory(tmp);
                        }}/>
                    </Grid>

                    <Grid item container direction={"row"} justifyContent={"center"}>
                        <Grid item>
                            <TextField sx={{margin: "1rem"}} inputProps={{min: 0, style: { textAlign: 'center' }}} type={"text"} label={"Lien du calendrier"} defaultValue={category.calendarLink} onChange={(event) => {
                                let tmp = category;
                                tmp.calendarLink = event.target.value;
                                setCategory(tmp);
                            }}/>
                        </Grid>

                        <Grid item>
                            <TextField sx={{margin: "1rem"}} inputProps={{min: 0, style: { textAlign: 'center' }}} type={"text"} label={"Lien du classement"} defaultValue={category.rankLink} onChange={(event) => {
                                let tmp = category;
                                tmp.rankLink = event.target.value;
                                setCategory(tmp);
                            }}/>
                        </Grid>
                    </Grid>
                </Grid>

                {error && props.category == null &&<small className={"text-danger col-12"}>Veuillez remplir tous les champs</small>}
                {error && props.category && <small className={"text-danger col-12"}>Le champ du nom d'équipe est obligatoire</small>}
            </PopupBody>

            <PopupFooter dismiss={"Annuler"} close={props.close}>
                <input className={"btn btn-primary"} type={"submit"} value={"Valider"}
                       onClick={() => {handleSubmit()}}/>
            </PopupFooter>
        </Popup>
    );
}